<template>
<!-- 支付提示页面 未使用 -->
  <div id="pay-method">
    <!-- 支付提示dialog -->
    hellow word
    <van-dialog id="pop-tips"
      v-model="showPayMethod"
      :show-confirm-button = false
      :before-close="beforeClose"

    >
    <div class="dialog-box">
      <div class="top-box">
      <div class="title-box">
        <span class="title-name">
          --支付金额--
        </span>
        <span class="title-money">9.9</span>
      </div>
      <div class="pay-box">
        <img src="../../assets/img/payimg/wechatPay.png" alt="" class="wechat-img">
      </div>
      </div>
    </div>
    </van-dialog>

    <van-dialog v-model = 'showPayMethod' :before-close="beforeClose" :show-confirm-button = false class="close-pop" >
      <div class="close-box">
        <img @click="closePop" src="../../assets/img/payimg/closePay.png" alt="" class="close-img">
      </div>
    </van-dialog>
    <!-- end -->
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    showPayMethod: {}
  },
  created () {
  },
  methods: {
    beforeClose () {},
    closePop () {
      this.$emit('closePop', false)
    }
  }
}
</script>

<style lang="postcss">
#pay-method {
  & #pop-tips {
    width: 600px;
    border-radius: 10px;
    position: absolute;
    & .top-box {
      width: 600px;
      background: rgba(255, 255, 253, 1);
    }
    & .dialog-box {
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      & .title-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 60px;
        border-bottom: 1px solid rgba(215, 215, 215, 1);
        & .title-name {
          font-size: 26px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
        & .title-money {
          font-size: 68px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          margin: 60px 0;
        }
      }
      & .pay-box {
        display: flex;
        justify-content: center;
        & .wechat-img {
          width: 239px;
          height: 64px;
          margin: 30px 0;
        }
      }
    }
  }
  & .close-pop {
    display: flex;
    justify-content: center;
    width: 60px;
    height: 60px;
    position: absolute;
    top: 75%;
    background: url('../../assets/img/payimg/closePay.png') no-repeat;
    background-size: 100%;
    & .close-img {
      width: 60px;
      height: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shenduPayAlert/SdPayMethod.vue